

export const Project = [
    { id: 3, 
        projectType: "js",
        image : "https://media1.giphy.com/media/fDxtUfyFNbNy99dG03/200.webp?cid=ecf05e479ym9tul8ga8dwicqbhqa8btvy07mitxlcbe0kcxx&ep=v1_gifs_search&rid=200.webp&ct=g",
        title: "Gaming Website",
        subTitle: "Venture into gaming world",
        gitHubLink : "https://github.com/Krish1rst/Animated-Gaming-website",
        liveLink :"https://3dgaming-website-clone.vercel.app/",
      },
    { id: 1, 
        projectType: "js",
        title: "SUSHIMAN",
       image : "https://media4.giphy.com/media/bPX0uyaWvJnsk/200.webp?cid=ecf05e47xq11amst60ae2i978km60cnfxco8xzf8f1iw5bqw&ep=v1_gifs_search&rid=200.webp&ct=g",
       subTitle: "Feel the taste of Japanese foods",
       gitHubLink : "https://github.com/Krish1rst/Shushi-Theme-website",
       liveLink :"https://shushi-themed-website.vercel.app/",
     },
     { id: 2, 
      title: 'iPhone15',
      subTitle: 'Apple website',
      image: 'https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZWUwa3puZGsyZzM3eWxtcmp5OWtycjJ3NzF1ZHN5MzF3d2E3NGdnbiZlcD12MV9naWZzX3NlYXJjaCZjdD1n/26n79t82lmj989iAE/200.webp',
      projectType: 'js',
      gitHubLink: 'https://github.com/Krish1rst/iPhone15-website',
      liveLink: 'https://iphone-animated-website-hazel.vercel.app/'
      },
      
      { id: 4, 
        projectType: "react",
        image : "https://media4.giphy.com/media/13Nc3xlO1kGg3S/200.webp?cid=ecf05e47mnfx0o4mfsoi7we9tzlahdn1dbr1f1y9jlqqpm0x&ep=v1_gifs_search&rid=200.webp&ct=g",
        title: "TWINTUBE",
        subTitle: "Youtube clone",
        gitHubLink : "https://github.com/Krish1rst/TwinTube",
        liveLink :"https://youtube-clone-sigma-indol.vercel.app/",
      },
      { id: 7, 
        projectType: "react",
        image : "https://media4.giphy.com/media/3BkLShek8qWJ2/200.webp?cid=790b7611b30ct2n9j5wj1o16k3jdy0w7ybybtffdpiqcvp3c&ep=v1_gifs_search&rid=200.webp&ct=g",
        title: "NIKE WEBSITE ",
        subTitle: "LANDING PAGE & MORE",
        gitHubLink : "https://github.com/Krish1rst/Nikes-Landing-Page",
        liveLink :"https://nikes-landing-page-gamma.vercel.app/",
      },
     
      { id: 6, 
        projectType: "react",
       image : "https://media0.giphy.com/media/h3oKKTT3pnwpZtUq9p/giphy.webp?cid=ecf05e47v9f0tjig0ogebsgvyvt3w8b98vx08fmnjuvdya4q&ep=v1_gifs_search&rid=giphy.webp&ct=g",
       title: "TEXTUTILS",
       subTitle: "TEXT MANIPULATION ",
       gitHubLink : "https://github.com/Krish1rst/TextUtils_Krishna",
       liveLink :"https://text-utils-krishna.vercel.app/",
     },
     
     { id: 5, 
      projectType: "react",
      image : "https://media2.giphy.com/media/3o6ZthWzyoIzSknltu/200.webp?cid=790b76118nrs9fqwnjfaz8osohzc4jhrpt78svl0vqhlj69a&ep=v1_gifs_search&rid=200.webp&ct=g",
      title: "NewsDaily",
      subTitle: "NEWS API/Not deployed",
      gitHubLink : "https://github.com/Krish1rst/NewsDaily",
      liveLink :"https://github.com/Krish1rst/NewsDaily",
    },

      { id: 8, 
        title: 'SHOPIFY ',
        subTitle: 'ECOMMERCE APP',
        image: 'https://media.istockphoto.com/id/1429456277/photo/online-shopping-with-credit-car-or-cash-money.jpg?s=612x612&w=0&k=20&c=l2uK4zXLwopGjxP3L5Fxn0GFQ129U_qvVLqXvqlcwwM=',
        projectType: 'mern',
        gitHubLink: 'https://github.com/Krish1rst/Shopify',
        liveLink: 'https://react-vite-comfy-store-v2.netlify.app/'
      },
     
      { id: 9, 
        title: 'SKETCH BOARD',
        subTitle: '(Real time collab)',
        image: 'https://media3.giphy.com/media/IdUmXODBzthtGp9sK2/200.webp?cid=ecf05e476g7mnoqqjfky11bz52eovv3np5lp6f5azgkuz2pr&ep=v1_gifs_search&rid=200.webp&ct=g',
        projectType: 'mern',
        gitHubLink: 'https://github.com/Krish1rst/Collaborative_Sketchboard',
        liveLink: 'https://github.com/Krish1rst/Collaborative_Sketchboard'
      },
      { id: 10, 
        title: 'BACKEND APIs',
        subTitle: 'Auth/ Store/Jobs APIs',
        image: 'https://media0.giphy.com/media/78XCFBGOlS6keY1Bil/giphy.webp?cid=790b7611ufvzyftlfv80plk69j4e2fz9odwdr6ojpe9rogpm&ep=v1_gifs_search&rid=giphy.webp&ct=g',
        projectType: 'mern',
        gitHubLink: 'https://github.com/Krish1rst/Backend-NodeProjects-Repo',
        liveLink: 'https://github.com/Krish1rst/Backend-NodeProjects-Repo'
      },
    
  ];

  